const initialState = {
    userProfilePermissions:[],
    userProfileLists: {},
    allUserLists: [],
    userProfileStatus: [],
    userProfileStatusCounts: {},
    changedUserProfileStatus : [],
    loadingUserProfile: false,
    errorsUserProfile: {},
    onboardingStatus: null,
    onboardingLoading: false,
    onboardingError: {}
}

const userProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_USER_PROFILE_PENDING":
        case "GET_ALL_USER_INTERVIEW_PENDING":
        case "GET_USER_PROFILE_STATUS_COUNTS_PENDING":
        case "ADD_USER_PROFILE_PENDING":
        case "ADD_USER_CONTACT_PENDING":
        case "ADD_USER_ADDRESS_PENDING":
        case "ADD_USER_BGV_ADDRESS_PENDING":
        case "ADD_USER_BGV_KYC_PENDING":
        case "ADD_USER_KYC_PENDING":
        case "ADD_USER_EDUCATION_PENDING":
        case "ADD_USER_EMPLOYMENT_PENDING":
        case "ADD_USER_SOCIAL_MEDIA_PENDING":
        case "ADD_USER_INTERVIEW_PENDING":
        case "ADD_USER_FAMILY_PENDING":
        case "ADD_USER_FAMILY_BGV_PENDING":
        case "ADD_USER_REFERENCES_PENDING":
        case "ADD_EMERGENCY_CONTACT_PENDING":
        case "ADD_USER_BGV_EMERGENCY_CONTACT_PENDING":
        case "ADD_USER_BANK_DETAILS_PENDING":
        case "ADD_USER_AGENT_VERIFICATION_PENDING":
        case "ADD_USER_CIBIL_CHECK_PENDING":
        case "ADD_POLICE_CRIMINAL_CHECK_PENDING":
        case "ADD_USER_RESCHEDULE_INTERVIEW_PENDING":
        case "ADD_USER_REJECT_CANDIDATE_PENDING":
        case "ADD_USER_HOLD_INTERVIEW_PENDING":
        case "ADD_USER_BGV_PENDING":
        case "ADD_USER_BGV_INTERVIEW_PENDING":
        case "ADD_USER_BGV_EMPLOYMENT_PENDING":
        case "ADD_USER_BGV_KYC_PENDING":
        case "ADD_USER_BGV_EDUCATION_PENDING":
        case "ADD_USER_INTERVIEW_DETAILS_PENDING":
        case "ADD_USER_BACKGROUND_VERIFICATION_SUMMARY_PENDING":
        case "ADD_USER_INSURANCE_POLICY_DETAILS_PENDING":
        case "ADD_USER_BGV_SOCIAL_MEDIA_PENDING":
        case "UPDATE_USER_PROFILE_PENDING":
        case "DELETE_USER_KYC_DETAILS_PENDING":
        case "DELETE_USER_EDUCATION_DETAILS_PENDING":
        case "DELETE_USER_RECORD_PENDING":
        case "ADD_USER_ONBOARDING_PROCESS_PENDING":
            return {
                ...state,
                loadingUserProfile: true,
                errorsUserProfile: {}
            };
        
        case "GET_USER_PROFILE_FULFILLED":
            return {
                ...state,
                loadingUserProfile: false,
                userProfileLists: action.payload?.data || {},
                userProfilePermissions: action.permissions || [],
                errorsUserProfile: {}
            };

        case "GET_ALL_USER_INTERVIEW_FULFILLED":
            return {
                ...state,
                loadingUserProfile: false,
                allUserLists: action.payload?.data || [],
                userProfileCount: action.count,
                userProfilePermissions: action.permissions || [],
                errorsUserProfile: {}
            };

        case "GET_USER_PROFILE_STATUS_COUNTS_FULFILLED":
            return {
                ...state,
                loadingUserProfile: false,
                userProfileStatusCounts: action.payload?.data || {},
                errorsUserProfile: {}
            };
            
            case "ADD_USER_PROFILE_FULFILLED":
            case "ADD_USER_CONTACT_FULFILLED":
            case "ADD_USER_ADDRESS_FULFILLED":
            case "ADD_USER_BGV_ADDRESS_FULFILLED":
            case "ADD_USER_BGV_KYC_FULFILLED":
            case "ADD_USER_KYC_FULFILLED":
            case "ADD_USER_EDUCATION_FULFILLED":
            case "ADD_USER_EMPLOYMENT_FULFILLED":
            case "ADD_USER_SOCIAL_MEDIA_FULFILLED":
            case "ADD_USER_INTERVIEW_FULFILLED":
            case "ADD_USER_FAMILY_FULFILLED":
            case "ADD_USER_FAMILY_BGV_FULFILLED":
            case "ADD_USER_REFERENCES_FULFILLED":
            case "ADD_EMERGENCY_CONTACT_FULFILLED":
            case "ADD_USER_BGV_EMERGENCY_CONTACT_FULFILLED":
            case "ADD_USER_BANK_DETAILS_FULFILLED":
            case "ADD_USER_AGENT_VERIFICATION_FULFILLED":
            case "ADD_POLICE_CRIMINAL_CHECK_FULFILLED":
            case "ADD_USER_CIBIL_CHECK_FULFILLED":
            case "ADD_USER_RESCHEDULE_INTERVIEW_FULFILLED":
            case "ADD_USER_REJECT_CANDIDATE_FULFILLED":
            case "ADD_USER_HOLD_INTERVIEW_FULFILLED":
            case "ADD_USER_BGV_FULFILLED":
            case "ADD_USER_BGV_INTERVIEW_FULFILLED":
            case "ADD_USER_BGV_EMPLOYMENT_FULFILLED":
            case "ADD_USER_INTERVIEW_DETAILS_FULFILLED":
            case "ADD_USER_BACKGROUND_VERIFICATION_SUMMARY_FULFILLED":
            case "ADD_USER_INSURANCE_POLICY_DETAILS_FULFILLED":
            case "DELETE_USER_KYC_DETAILS_FULFILLED":
            case "DELETE_USER_EDUCATION_DETAILS_FULFILLED":
            case "ADD_USER_BGV_SOCIAL_MEDIA_FULFILLED":
            case "ADD_USER_BGV_KYC_FULFILLED":
            case "ADD_USER_BGV_EDUCATION_FULFILLED":
                return {
                    ...state,
                    loadingUserProfile: false,
                    changedUserProfileStatus: action.payload,
                    userProfilePermissions: action.permissions || [],
                    errorsUserProfile: {}
                };

            // Shared delete for contact/address/family/emergency/reference —
            // do not set changedUserProfileStatus (education form reset stays education-only).
            case "DELETE_USER_RECORD_FULFILLED":
                return {
                    ...state,
                    loadingUserProfile: false,
                    errorsUserProfile: {}
                };

                case "ADD_USER_ONBOARDING_PROCESS_FULFILLED":
            return {
                ...state,
                loadingUserProfile: false,
                onboardingLoading: false,
                onboardingStatus: action.payload,
                onboardingError: {}
            };
            
            case "UPDATE_USER_PROFILE_FULFILLED":
                return {
                    ...state,
                    loadingUserProfile: false,
                    userProfilePermissions: action.permissions || [],
                    errorsUserProfile: {}
                };

        case "GET_USER_PROFILE_REJECTED":
        case "GET_ALL_USER_INTERVIEW_REJECTED":
        case "GET_USER_PROFILE_STATUS_COUNTS_REJECTED":
        case "ADD_USER_PROFILE_REJECTED":
        case "ADD_USER_CONTACT_REJECTED":
        case "ADD_USER_ADDRESS_REJECTED":
        case "ADD_USER_BGV_ADDRESS_REJECTED":
        case "ADD_USER_BGV_KYC_REJECTED":
        case "ADD_USER_KYC_REJECTED":
        case "ADD_USER_EDUCATION_REJECTED":
        case "ADD_USER_EMPLOYMENT_REJECTED":
        case "ADD_USER_SOCIAL_MEDIA_REJECTED":
        case "ADD_USER_INTERVIEW_REJECTED":
        case "ADD_USER_FAMILY_REJECTED":
        case "ADD_USER_FAMILY_BGV_REJECTED":
        case "ADD_USER_REFERENCES_REJECTED":
        case "ADD_EMERGENCY_CONTACT_REJECTED":
        case "ADD_USER_BGV_EMERGENCY_CONTACT_REJECTED":
        case "ADD_USER_BANK_DETAILS_REJECTED":
        case "ADD_USER_AGENT_VERIFICATION_REJECTED":
        case "ADD_POLICE_CRIMINAL_CHECK_REJECTED":
        case "ADD_USER_CIBIL_CHECK_REJECTED":
        case "ADD_USER_RESCHEDULE_INTERVIEW_REJECTED":
        case "ADD_USER_REJECT_CANDIDATE_REJECTED":
        case "ADD_USER_HOLD_INTERVIEW_REJECTED":
        case "ADD_USER_BGV_REJECTED":
        case "ADD_USER_BGV_INTERVIEW_REJECTED":
        case "ADD_USER_BGV_EMPLOYMENT_REJECTED":
        case "ADD_USER_INTERVIEW_DETAILS_REJECTED":
        case "ADD_USER_BACKGROUND_VERIFICATION_SUMMARY_REJECTED":
        case "ADD_USER_INSURANCE_POLICY_DETAILS_REJECTED":
        case "ADD_USER_BGV_SOCIAL_MEDIA_REJECTED":
        case "UPDATE_USER_PROFILE_REJECTED":
        case "DELETE_USER_PROFILE_REJECTED":
        case "DELETE_USER_KYC_DETAILS_REJECTED":
        case "DELETE_USER_EDUCATION_DETAILS_REJECTED":
        case "DELETE_USER_RECORD_REJECTED":
        case "ADD_USER_BGV_KYC_REJECTED":
        case "ADD_USER_BGV_EDUCATION_REJECTED":
            return {
                ...state,
                loadingUserProfile: false,
                errorsUserProfile: action.payload
            };

            case "ADD_USER_ONBOARDING_PROCESS_REJECTED":
                return {
                    ...state,
                    loadingUserProfile: false,
                    onboardingLoading: false,
                    onboardingStatus: null,
                    onboardingError: action.payload
                };
        

        case "RESET_USER_PROFILE_STATUS":
            return {
                ...state,
                loadingUserProfile: false,
                changedUserProfileStatus: [],
                errorsUserProfile: {}
            };


        case "RESET_USER_PROFILE_LIST":
            return {
                ...state,
                loadingUserProfile: false,
                userProfileLists: {}
            };

        case "CLEAR_USER_PROFILE_ERRORS":
            return {
                ...state,
                errorsUserProfile: {}
            };

        default:
            return state;
    }
}

export default userProfileReducer;